import { inject } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, filter, map, mergeMap, of } from 'rxjs';

import { CancelBlueSagePayLinkGQL } from 'src/generated/graphql.generated';

import { CancelPayLinkDialogActions } from './cancel-pay-link-dialog.actions';
import { cancelPayLinkDialogFeature } from './cancel-pay-link-dialog.feature';

/** Withdraw a live pay link only after the administrator confirms the row target. */
export const cancelBlueSagePayLink = createEffect((
    actions$ = inject(Actions),
    store = inject(Store),
    cancelGQL = inject(CancelBlueSagePayLinkGQL),
) => {
    return actions$.pipe(
        ofType(CancelPayLinkDialogActions.cancelPayLinkConfirmed),
        exhaustMap((action) => of(action).pipe(
            concatLatestFrom(() => store.select(cancelPayLinkDialogFeature.selectTarget)),
            filter(([ , target ]) => Boolean(target?.transactionId)),
            mergeMap(([ , target ]) => cancelGQL.mutate({
                transactionId: target!.transactionId,
            }).pipe(
                map((res) => CancelPayLinkDialogActions.cancelPayLinkSuccess({
                    transactionId: res.data.cancelBlueSagePayLink.transactionId,
                })),
            )),
            catchError((error) => of(CancelPayLinkDialogActions.cancelPayLinkError({ error }))),
        )),
    );
}, { functional: true, dispatch: true });
